import { Model } from "@nozbe/watermelondb";
import { text, date, readonly, relation } from "@nozbe/watermelondb/decorators";
import Customer from "./customer";

export default class SmsMessage extends Model {
  static table = "sms_messages";

  @relation("customers", "customer_id") customer?: Customer;
  // "out" = sent by us, "in" = reply from the customer
  @text("direction") direction?: string;
  @text("body") body?: string;
  @text("to_number") toNumber?: string;
  @text("from_number") fromNumber?: string;
  // queued (waiting to sync), sent, failed, received
  @text("status") status?: string;
  @text("error") error?: string;

  @readonly @date("created_at") createdAt?: number;
  @readonly @date("updated_at") updatedAt?: number;
}
